import React from 'react';
import PropTypes from 'prop-types';
import { CheckingValidComment, getCommentErrorMsg } from '../../lib/common';

const AttachmentsView = ({
  style,
  attachmentsArr,
  comment,
  keyVal,
  handleAddAttachment,
  handleDeleteAttachment,
  handleCommentChange,
}) => {
  return (
    <>
      <div className={`${style.Attachment__Box} mt-12`}>
        <div className={`${style.Attachment__Left}`}>
          <div className="font12 fw500 color777">Attachment</div>
          <div className="font11 fw700 color777">(Max 3)</div>
        </div>

        <label
          htmlFor={`coverImage_banner_${keyVal}`}
          className={`${style.Attachment__Button} ${attachmentsArr?.length > 2 ? style.Disabled : ''}`}
        >
          <input
            id={`coverImage_banner_${keyVal}`}
            type="file"
            hidden
            accept="image/*"
            onChange={(e) => {
              handleAddAttachment(e, keyVal);
            }}
            onClick={async (e) => {
              if (attachmentsArr?.length > 2) {
                e.preventDefault();
              } else {
                e.target.value = null;
              }
            }}
            name=""
          />
          <div className={`csicon ${style.Attachment__Icon}`} />
          <div className="font12 fw600">Add Attachment</div>
        </label>
      </div>
      <ul className={`${style.AttachmentList} mt-12`}>
        {attachmentsArr?.length > 0
          ? attachmentsArr?.map((attachment, idx) => (
              <li className={`${style.AttachmentItem}`} key={idx}>
                <div className={`${style.Attachment__ImgBox}`}>
                  <img src={attachment.url} alt={attachment.name} className={`${style.Attachment__Image}`} />
                </div>
                <div className={`${style.Attachment__Text}`}>
                  <div className={`${style.Big} font11 fw400 color111`}>{attachment.name}</div>
                  <div className={`${style.Small} font11 fw400 color777`}>{attachment.size}</div>
                </div>
                <div
                  role="presentation"
                  onClick={() => handleDeleteAttachment(keyVal, idx)}
                  className={`${style.Attachment__Close} csicon `}
                />
              </li>
            ))
          : null}
      </ul>

      <div className="mt-12">
        <textarea
          value={comment || ''}
          onChange={(e) => handleCommentChange(keyVal, e.target.value, 'comment')}
          className={`${style.Summary__TextArea} font12 fw500 color111`}
          placeholder="Comment here*"
          rows="4"
        />

        {comment && !CheckingValidComment(comment.trim()) && comment?.trim()?.length > 3 && (
          <div className="colorEC4 font12">{getCommentErrorMsg(comment)}</div>
        )}
      </div>
    </>
  );
};

export default AttachmentsView;
AttachmentsView.propTypes = {
  style: PropTypes.object,
  attachmentsArr: PropTypes.array,
  comment: PropTypes.string,
  keyVal: PropTypes.string,
  handleAddAttachment: PropTypes.func,
  handleDeleteAttachment: PropTypes.func,
  handleCommentChange: PropTypes.func,
};
